// We only want to allow returning to a url with a Codat domain after login, to prevent users being redirected to a malicious page
const SAFE_DOMAINS = ["codat.io", "codatprivate.io"];

export function isCodatUrl(url: string) {
  let parsedUrl;
  try {
    parsedUrl = new URL(url);
  } catch (err) {
    return false;
  }

  if (
    parsedUrl.hostname === "localhost" ||
    (parsedUrl.protocol === "https:" &&
      SAFE_DOMAINS.includes(parsedUrl.hostname.split(".").slice(-2).join(".")))
  ) {
    return true;
  }
  return false;
}
